import { useMemo } from 'react';
import GTable from '../../../../components/elements/GTable';
import Button from '../../../../components/form-control/Button';
import Page from '../../../../components/PageWrapper';
import useModal from '../../../../hooks/modalHook';
import AddWorkspace from './AddWorkspace';
import PolicyStatus from '../../../../components/elements/PolicyStatus';
import useUserAccount from '../../../../hooks/userAccountHook';
import usePartner from '../../../../hooks/partnerHook';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import useSlack from '../../../../hooks/slackHook';
interface SlackProps {
    isSettings?: boolean;
}

const Slack = ({isSettings = false}: SlackProps) => {
    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const { user } = useUserAccount();
    const { getAllSlackWorkspaces } = usePartner();
    const invalidatequery = useQueryClient();
    const {showAddWorkspaceModal, SlackModal} = useSlack();

    const { data: workspaces, isLoading } = useQuery({
        queryKey: ['workspaces'],
        queryFn: getAllSlackWorkspaces,
    })

    const columns = useMemo(
        () => [

            {
                Header: 'M',
                columns: [
                    {
                        Header: 'Name',
                        accessor: 'name',
                        Cell: (row: any) => {
                            return (
                                <span>{row.cell.value ? row.cell.value : '-'}</span>
                            );
                        }
                    },

                    {
                        Header: 'Description',
                        accessor: 'description',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? row.cell.value : '-'}</span>;
                        }
                    },

                    {
                        Header: 'Status',
                        accessor: 'active',
                        Cell: (row: any) => {
                            return <PolicyStatus status={row.cell.value ? 'Active' : 'Inactive'} />;
                        }
                    }


                ]
            }
        ],
        []
    );

    return (
        <Page title="Slack workspace" className="">
            <div className="p-5 bg-white dark:bg-darkBg  min-h-full">
                <div className="flex items-center justify-between">
                    <>
                        {user.isOwner() && !isSettings &&
                            <Button
                                label="Add workspace"
                                className=""
                                bgColor="primary"
                                curved
                                onClick={showAddWorkspaceModal}
                            />
                        }
                    </>
                </div>

                {workspaces && (
                    <div className="py-6">
                        <GTable
                            selectionChanged={(selection: any) => {
                            }}
                            showSearch={false}
                            columns={columns}
                            data={workspaces}
                            classes="h-fit overflow-x-auto "
                            tableType={'workspace'}
                            loading={isLoading}
                        />
                    </div>
                )}

                <ModalComponent />
                <SlackModal />
            </div>
        </Page>
    );
};

export default Slack;
